module.exports = __webpack_public_path__ + "static/img/ptherleft.01e802f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ptherleft.png
// module id = 3sz0
// module chunks = 1